import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { submit } from "./actions";
import Component, { type ActionProps, type MapProps } from "./component";
import { localStateSelector, makeFieldsSelector, makeProductSelector } from "./selectors";
import { type CheckoutButton } from "./types";

const makeMapStateToProps = () => {
  const fieldsSelector = makeFieldsSelector();
  const productSelector = makeProductSelector();

  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      fields: fieldsSelector(state, props),
      isEditMode: state.isEditMode,
      product: productSelector(state, props),
      status: localState.status
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({
  onClick: (data: CheckoutButton.View.AddToCartFormData) =>
    dispatch(submit({ id: props.id, source: props.source }, data))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
